import { PLATFORMS } from '../enums/platforms';

export default function PlatformLogo({ platformKey, style }) {
    const platform = PLATFORMS[platformKey];
    if (!platform?.logo) return null;

    return (
        <img
            src={platform.logo}
            alt={platform.name}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px',
                overflow: 'hidden',
                height: '94%',
                aspectRatio: '1',
                boxSizing: 'border-box',
                maxWidth: '38px',
                border: '1px solid rgba(255, 255, 255, 1)',
                ...style
            }}
        />
    );
}
